import i18n from "@/shared/config/i18n";

function currentLocale() {
  const raw =
    (i18n.global && (i18n.global.locale?.value || i18n.global.locale)) ||
    localStorage.getItem("lang") ||
    "ru";
  return raw === "kk" ? "kk" : "ru";
}

/**
 * Maps a Centrifuge WS payload to the canonical REST-shaped Notification.
 * WS shape (see src/notification/format.md):
 *   { uuid, payload: { event_uuid, title, title_kk, description, description_kk,
 *     service, status, status_code, options, source_key }, path_list, type }
 *
 * @param {any} raw  data from centrifuge publication
 * @param {string} [forceLocale]
 * @returns {import('./types').Notification|null}
 */
export function wsToNotification(raw, forceLocale) {
  if (!raw) return null;

  const envelope = raw.payload ? raw : { payload: raw };
  const payload = envelope.payload || {};
  const locale = forceLocale || currentLocale();
  const isKk = locale === "kk";

  const title =
    (isKk ? payload.title_kk : payload.title) ||
    payload.title ||
    payload.title_kk ||
    "";
  const body =
    (isKk ? payload.description_kk : payload.description) ||
    payload.description ||
    payload.description_kk ||
    "";

  const uuid = envelope.uuid || payload.uuid || payload.event_uuid;
  if (!uuid) return null;

  return {
    uuid,
    event_uuid: payload.event_uuid || envelope.event_uuid || uuid,
    title,
    body,
    type: payload.service || payload.type || envelope.type || null,
    status: payload.status_code || payload.status || null,
    read_at: null,
    options: payload.options || {},
    user_uuid: envelope.user_uuid || payload.user_uuid || null,
    recipient_id: envelope.recipient_id || null,
    created_at: payload.created_at || new Date().toISOString(),
  };
}
